import { useState, useEffect } from "react";
import {
  FIELD_SALES,
  INSIDE_SALES,
  OTHER,
  RETAIL_ADVISOR,
  THIRD_PARTY_RETAIL_ADVISOR,
  UserProfile,
} from "@sunrun/sales-experience-shared";
import { singletonHook } from "react-singleton-hook";
import { SalesExpApi } from "./Api";
import { useHybridToken } from "./Auth";
import { rollbar } from "./rollbar";
import { identify as identifyFullStoryUser } from "./FullStory";
import { Mixpanel } from "./mixpanel";

const useUserProfileImpl = () => {
  const [userProfile, setUserProfile] = useState({} as UserProfile);
  const [completeProfile, setCompleteProfile] = useState({} as UserProfile);

  const hybridToken = useHybridToken();
  useEffect(() => {
    if (hybridToken) {
      SalesExpApi.getUserProfile(hybridToken)
        .then((res) => {
          identifyFullStoryUser(res.email);
          Mixpanel.identify(res.email);
          rollbar.configure({
            payload: {
              profile: {
                id: res.email,
                email: res.email,
              },
              userProfile: {
                ...res,
              },
            },
          });
          setUserProfile({
            ...(res.sfdcContact ?? res),
          });
          setCompleteProfile({
            ...res,
          });
        })
        .catch(() => {
          // TODO: Fix under SPLAT1-6940
          // Do nothing
        });
    } else {
      setUserProfile({} as UserProfile);
      setCompleteProfile({} as UserProfile);
    }
  }, [hybridToken]);

  useEffect(() => {
    const retailEnabledRoles = [
      INSIDE_SALES,
      FIELD_SALES,
      RETAIL_ADVISOR,
      THIRD_PARTY_RETAIL_ADVISOR,
      OTHER,
    ];
    // This function is used to pre-fetch retail store addresses from the API and reduced perceived wait time
    if (hybridToken && retailEnabledRoles.includes(userProfile.splatRole)) {
      SalesExpApi.getRetailStoreAddresses(hybridToken);
    }
  }, [hybridToken, userProfile]);

  return { userProfile, completeProfile };
};

const useUserProfile = singletonHook(
  { userProfile: {} as UserProfile, completeProfile: {} as UserProfile },
  useUserProfileImpl
);

export { useUserProfile };
